module.exports = __webpack_public_path__ + "img/small_whale19.e8b36bc7.jpg";